import { inViewCallback } from '../function/inview';

// Define the elements you want to intiate an action on
const page = document.querySelector('.FeatureArticlePage');

const observedElements = page ? page.querySelectorAll(
    '.inview-wrapper img, .feature-page-intro__title, .feature-page-intro__byline, .feature-page-intro__introduction, .feature-page-intro__cta, .video-block'
) : [];

observedElements.forEach((element) => {
    element.classList.add('inview');
});

const options = {
    //define your options
    threshold: 0.25,
    // rootMargin: '0px 0px -50px 0px',
};

// create a new instance using our callback which contains our elements and actions, using the options we defined
const observer = new IntersectionObserver(inViewCallback, options);

observedElements.forEach((element) => {
    observer.observe(element); // run the observer
});
